/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForOperationAssessment extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForOperationAssessment");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForOperationAssessment.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForOperationAssessment>): BackgroundJobPayloadForOperationAssessment {
        let obj = Object.assign(new BackgroundJobPayloadForOperationAssessment(), model);
        BackgroundJobPayloadForOperationAssessment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForOperationAssessment>): BackgroundJobPayloadForOperationAssessment {
        if (!model) return null;
        return BackgroundJobPayloadForOperationAssessment.newInstance(<BackgroundJobPayloadForOperationAssessment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForOperationAssessment) {
        if (!obj) return;

        models.BackgroundJobPayloadForOperationAssessment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForOperationAssessment): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForOperationAssessment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

    /**
     * Sync Type of Operations Assessment
     */
    sync_type: models.OperationsAssessmentSyncType;

}
